export enum FeatureEntitlements {
  Navigation = 'navigation',
}
